import { default as DownloadszJWYeaqTDkMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Downloads.vue?macro=true";
import { default as CallCenterQgv4DLvZWvMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Features/CallCenter.vue?macro=true";
import { default as TeamWorkm7Mewn93VOMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Features/TeamWork.vue?macro=true";
import { default as ApplyBVXofjlDe7Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/Apply.vue?macro=true";
import { default as DetailswMdjNEFf0qMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/Details.vue?macro=true";
import { default as ListkRLWlEWl55Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/List.vue?macro=true";
import { default as PricesrYGIr9OTbbMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Prices.vue?macro=true";
import { default as SupportLl2iSWzQyeMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Support.vue?macro=true";
import { default as about_45usmU1yp7NsooMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/about-us.vue?macro=true";
import { default as connecting_45with_45crm5YR4slR4crMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/connecting-with-crm.vue?macro=true";
import { default as contact_45uszyrSRHhXMnMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/contact-us.vue?macro=true";
import { default as indexLaYPgFlyCSMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/index.vue?macro=true";
import { default as landingV5eR4Xhq3kMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/internet-phone/landing.vue?macro=true";
import { default as indexymjK6tDUCNMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/iran-telecom/index.vue?macro=true";
import { default as callcenter82sLDsrNeMMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/callcenter.vue?macro=true";
import { default as cloud_45pbxZKROYLcJXxMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/cloud-pbx.vue?macro=true";
import { default as faxUBVuPXjAUIMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/fax.vue?macro=true";
import { default as indexFdam9L3Ib6Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/index.vue?macro=true";
import { default as webchattEFxt6wOe4Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/webchat.vue?macro=true";
import { default as contactBBVL8awKYBMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/managers/contact.vue?macro=true";
import { default as indexXXhi9oWHeeMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/managers/index.vue?macro=true";
import { default as metamaox8fFtXLqqMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/metama.vue?macro=true";
import { default as numbers_45opal0ImiIhd7O5Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/numbers-opal.vue?macro=true";
import { default as numbers7d4V90IoCmMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/numbers.vue?macro=true";
import { default as buy6VtU74smuJMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/buy.vue?macro=true";
import { default as cloud_45callcenterQ5VaQd6sEuMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/cloud-callcenter.vue?macro=true";
import { default as internet_45phoneBchkAh4enpMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/internet-phone.vue?macro=true";
import { default as metamabLYX7vPcFvMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/metama.vue?macro=true";
import { default as thankyouVrtUe9lIQHMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/thankyou.vue?macro=true";
import { default as CallCenterJitUWE7CXeMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/CallCenter.vue?macro=true";
import { default as FaxCBlsAbvg6ZMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/Fax.vue?macro=true";
import { default as cloud_45call_45centerMrE01gvl9SMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-call-center.vue?macro=true";
import { default as cloud_45callcenterTh0GGDF8tVMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-callcenter.vue?macro=true";
import { default as cloud_45pbxBO2TGEUONVMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-pbx.vue?macro=true";
import { default as crm4OISCaAjElMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/crm.vue?macro=true";
import { default as dedicated_45applicationQI9RmwjfMJMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/dedicated-application.vue?macro=true";
import { default as internet_45phonerJwW5u5123Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/internet-phone.vue?macro=true";
import { default as management_45dashboardKMxp116hpKMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/management-dashboard.vue?macro=true";
import { default as smart_45IVROfgrDU3OnPMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/smart-IVR.vue?macro=true";
import { default as smsbBuPq0ABjlMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/sms.vue?macro=true";
import { default as virtual_45office0raXkWEjgBMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/virtual-office.vue?macro=true";
import { default as webchata1PeYWFmnSMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/webchat.vue?macro=true";
import { default as rondEZjXEp97X1Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/rond.vue?macro=true";
import { default as sales_45agentl86NcZKjZ7Meta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/sales-agent.vue?macro=true";
import { default as wf_45iranelecomp_45leadLVHDNJcolwMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-iranelecomp-lead.vue?macro=true";
import { default as wf_45iranelecomp_45salesagentnifvuYqcxIMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-iranelecomp-salesagent.vue?macro=true";
import { default as wf_45irantelecom_45leadQSaS0wNxXJMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-irantelecom-lead.vue?macro=true";
import { default as wf_45irantelecom_45salesagenthygLvr0wPkMeta } from "C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-irantelecom-salesagent.vue?macro=true";
export default [
  {
    name: DownloadszJWYeaqTDkMeta?.name ?? "Downloads",
    path: DownloadszJWYeaqTDkMeta?.path ?? "/Downloads",
    meta: DownloadszJWYeaqTDkMeta || {},
    alias: DownloadszJWYeaqTDkMeta?.alias || [],
    redirect: DownloadszJWYeaqTDkMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Downloads.vue").then(m => m.default || m)
  },
  {
    name: CallCenterQgv4DLvZWvMeta?.name ?? "Features-CallCenter",
    path: CallCenterQgv4DLvZWvMeta?.path ?? "/Features/CallCenter",
    meta: CallCenterQgv4DLvZWvMeta || {},
    alias: CallCenterQgv4DLvZWvMeta?.alias || [],
    redirect: CallCenterQgv4DLvZWvMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Features/CallCenter.vue").then(m => m.default || m)
  },
  {
    name: TeamWorkm7Mewn93VOMeta?.name ?? "Features-TeamWork",
    path: TeamWorkm7Mewn93VOMeta?.path ?? "/Features/TeamWork",
    meta: TeamWorkm7Mewn93VOMeta || {},
    alias: TeamWorkm7Mewn93VOMeta?.alias || [],
    redirect: TeamWorkm7Mewn93VOMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Features/TeamWork.vue").then(m => m.default || m)
  },
  {
    name: ApplyBVXofjlDe7Meta?.name ?? "Jobs-Apply",
    path: ApplyBVXofjlDe7Meta?.path ?? "/Jobs/Apply",
    meta: ApplyBVXofjlDe7Meta || {},
    alias: ApplyBVXofjlDe7Meta?.alias || [],
    redirect: ApplyBVXofjlDe7Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/Apply.vue").then(m => m.default || m)
  },
  {
    name: DetailswMdjNEFf0qMeta?.name ?? "Jobs-Details",
    path: DetailswMdjNEFf0qMeta?.path ?? "/Jobs/Details",
    meta: DetailswMdjNEFf0qMeta || {},
    alias: DetailswMdjNEFf0qMeta?.alias || [],
    redirect: DetailswMdjNEFf0qMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/Details.vue").then(m => m.default || m)
  },
  {
    name: ListkRLWlEWl55Meta?.name ?? "Jobs-List",
    path: ListkRLWlEWl55Meta?.path ?? "/Jobs/List",
    meta: ListkRLWlEWl55Meta || {},
    alias: ListkRLWlEWl55Meta?.alias || [],
    redirect: ListkRLWlEWl55Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Jobs/List.vue").then(m => m.default || m)
  },
  {
    name: PricesrYGIr9OTbbMeta?.name ?? "Prices",
    path: PricesrYGIr9OTbbMeta?.path ?? "/Prices",
    meta: PricesrYGIr9OTbbMeta || {},
    alias: PricesrYGIr9OTbbMeta?.alias || [],
    redirect: PricesrYGIr9OTbbMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Prices.vue").then(m => m.default || m)
  },
  {
    name: SupportLl2iSWzQyeMeta?.name ?? "Support",
    path: SupportLl2iSWzQyeMeta?.path ?? "/Support",
    meta: SupportLl2iSWzQyeMeta || {},
    alias: SupportLl2iSWzQyeMeta?.alias || [],
    redirect: SupportLl2iSWzQyeMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/Support.vue").then(m => m.default || m)
  },
  {
    name: about_45usmU1yp7NsooMeta?.name ?? "about-us",
    path: about_45usmU1yp7NsooMeta?.path ?? "/about-us",
    meta: about_45usmU1yp7NsooMeta || {},
    alias: about_45usmU1yp7NsooMeta?.alias || [],
    redirect: about_45usmU1yp7NsooMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: connecting_45with_45crm5YR4slR4crMeta?.name ?? "connecting-with-crm",
    path: connecting_45with_45crm5YR4slR4crMeta?.path ?? "/connecting-with-crm",
    meta: connecting_45with_45crm5YR4slR4crMeta || {},
    alias: connecting_45with_45crm5YR4slR4crMeta?.alias || [],
    redirect: connecting_45with_45crm5YR4slR4crMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/connecting-with-crm.vue").then(m => m.default || m)
  },
  {
    name: contact_45uszyrSRHhXMnMeta?.name ?? "contact-us",
    path: contact_45uszyrSRHhXMnMeta?.path ?? "/contact-us",
    meta: contact_45uszyrSRHhXMnMeta || {},
    alias: contact_45uszyrSRHhXMnMeta?.alias || [],
    redirect: contact_45uszyrSRHhXMnMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: indexLaYPgFlyCSMeta?.name ?? "index",
    path: indexLaYPgFlyCSMeta?.path ?? "/",
    meta: indexLaYPgFlyCSMeta || {},
    alias: indexLaYPgFlyCSMeta?.alias || [],
    redirect: indexLaYPgFlyCSMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/index.vue").then(m => m.default || m)
  },
  {
    name: landingV5eR4Xhq3kMeta?.name ?? "internet-phone-landing",
    path: landingV5eR4Xhq3kMeta?.path ?? "/internet-phone/landing",
    meta: landingV5eR4Xhq3kMeta || {},
    alias: landingV5eR4Xhq3kMeta?.alias || [],
    redirect: landingV5eR4Xhq3kMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/internet-phone/landing.vue").then(m => m.default || m)
  },
  {
    name: indexymjK6tDUCNMeta?.name ?? "iran-telecom",
    path: indexymjK6tDUCNMeta?.path ?? "/iran-telecom",
    meta: indexymjK6tDUCNMeta || {},
    alias: indexymjK6tDUCNMeta?.alias || [],
    redirect: indexymjK6tDUCNMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/iran-telecom/index.vue").then(m => m.default || m)
  },
  {
    name: callcenter82sLDsrNeMMeta?.name ?? "landing-callcenter",
    path: callcenter82sLDsrNeMMeta?.path ?? "/landing/callcenter",
    meta: callcenter82sLDsrNeMMeta || {},
    alias: callcenter82sLDsrNeMMeta?.alias || [],
    redirect: callcenter82sLDsrNeMMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/callcenter.vue").then(m => m.default || m)
  },
  {
    name: cloud_45pbxZKROYLcJXxMeta?.name ?? "landing-cloud-pbx",
    path: cloud_45pbxZKROYLcJXxMeta?.path ?? "/landing/cloud-pbx",
    meta: cloud_45pbxZKROYLcJXxMeta || {},
    alias: cloud_45pbxZKROYLcJXxMeta?.alias || [],
    redirect: cloud_45pbxZKROYLcJXxMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/cloud-pbx.vue").then(m => m.default || m)
  },
  {
    name: faxUBVuPXjAUIMeta?.name ?? "landing-fax",
    path: faxUBVuPXjAUIMeta?.path ?? "/landing/fax",
    meta: faxUBVuPXjAUIMeta || {},
    alias: faxUBVuPXjAUIMeta?.alias || [],
    redirect: faxUBVuPXjAUIMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/fax.vue").then(m => m.default || m)
  },
  {
    name: indexFdam9L3Ib6Meta?.name ?? "landing",
    path: indexFdam9L3Ib6Meta?.path ?? "/landing",
    meta: indexFdam9L3Ib6Meta || {},
    alias: indexFdam9L3Ib6Meta?.alias || [],
    redirect: indexFdam9L3Ib6Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/index.vue").then(m => m.default || m)
  },
  {
    name: webchattEFxt6wOe4Meta?.name ?? "landing-webchat",
    path: webchattEFxt6wOe4Meta?.path ?? "/landing/webchat",
    meta: webchattEFxt6wOe4Meta || {},
    alias: webchattEFxt6wOe4Meta?.alias || [],
    redirect: webchattEFxt6wOe4Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/landing/webchat.vue").then(m => m.default || m)
  },
  {
    name: contactBBVL8awKYBMeta?.name ?? "managers-contact",
    path: contactBBVL8awKYBMeta?.path ?? "/managers/contact",
    meta: contactBBVL8awKYBMeta || {},
    alias: contactBBVL8awKYBMeta?.alias || [],
    redirect: contactBBVL8awKYBMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/managers/contact.vue").then(m => m.default || m)
  },
  {
    name: indexXXhi9oWHeeMeta?.name ?? "managers",
    path: indexXXhi9oWHeeMeta?.path ?? "/managers",
    meta: indexXXhi9oWHeeMeta || {},
    alias: indexXXhi9oWHeeMeta?.alias || [],
    redirect: indexXXhi9oWHeeMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/managers/index.vue").then(m => m.default || m)
  },
  {
    name: metamaox8fFtXLqqMeta?.name ?? "metama",
    path: metamaox8fFtXLqqMeta?.path ?? "/metama",
    meta: metamaox8fFtXLqqMeta || {},
    alias: metamaox8fFtXLqqMeta?.alias || [],
    redirect: metamaox8fFtXLqqMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/metama.vue").then(m => m.default || m)
  },
  {
    name: numbers_45opal0ImiIhd7O5Meta?.name ?? "numbers-opal",
    path: numbers_45opal0ImiIhd7O5Meta?.path ?? "/numbers-opal",
    meta: numbers_45opal0ImiIhd7O5Meta || {},
    alias: numbers_45opal0ImiIhd7O5Meta?.alias || [],
    redirect: numbers_45opal0ImiIhd7O5Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/numbers-opal.vue").then(m => m.default || m)
  },
  {
    name: numbers7d4V90IoCmMeta?.name ?? "numbers",
    path: numbers7d4V90IoCmMeta?.path ?? "/numbers",
    meta: numbers7d4V90IoCmMeta || {},
    alias: numbers7d4V90IoCmMeta?.alias || [],
    redirect: numbers7d4V90IoCmMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/numbers.vue").then(m => m.default || m)
  },
  {
    name: buy6VtU74smuJMeta?.name ?? "online-shopping-buy",
    path: buy6VtU74smuJMeta?.path ?? "/online-shopping/buy",
    meta: buy6VtU74smuJMeta || {},
    alias: buy6VtU74smuJMeta?.alias || [],
    redirect: buy6VtU74smuJMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/buy.vue").then(m => m.default || m)
  },
  {
    name: cloud_45callcenterQ5VaQd6sEuMeta?.name ?? "online-shopping-cloud-callcenter",
    path: cloud_45callcenterQ5VaQd6sEuMeta?.path ?? "/online-shopping/cloud-callcenter",
    meta: cloud_45callcenterQ5VaQd6sEuMeta || {},
    alias: cloud_45callcenterQ5VaQd6sEuMeta?.alias || [],
    redirect: cloud_45callcenterQ5VaQd6sEuMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/cloud-callcenter.vue").then(m => m.default || m)
  },
  {
    name: internet_45phoneBchkAh4enpMeta?.name ?? "online-shopping-internet-phone",
    path: internet_45phoneBchkAh4enpMeta?.path ?? "/online-shopping/internet-phone",
    meta: internet_45phoneBchkAh4enpMeta || {},
    alias: internet_45phoneBchkAh4enpMeta?.alias || [],
    redirect: internet_45phoneBchkAh4enpMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/internet-phone.vue").then(m => m.default || m)
  },
  {
    name: metamabLYX7vPcFvMeta?.name ?? "online-shopping-metama",
    path: metamabLYX7vPcFvMeta?.path ?? "/online-shopping/metama",
    meta: metamabLYX7vPcFvMeta || {},
    alias: metamabLYX7vPcFvMeta?.alias || [],
    redirect: metamabLYX7vPcFvMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/metama.vue").then(m => m.default || m)
  },
  {
    name: thankyouVrtUe9lIQHMeta?.name ?? "online-shopping-thankyou",
    path: thankyouVrtUe9lIQHMeta?.path ?? "/online-shopping/thankyou",
    meta: thankyouVrtUe9lIQHMeta || {},
    alias: thankyouVrtUe9lIQHMeta?.alias || [],
    redirect: thankyouVrtUe9lIQHMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/online-shopping/thankyou.vue").then(m => m.default || m)
  },
  {
    name: CallCenterJitUWE7CXeMeta?.name ?? "products-CallCenter",
    path: CallCenterJitUWE7CXeMeta?.path ?? "/products/CallCenter",
    meta: CallCenterJitUWE7CXeMeta || {},
    alias: CallCenterJitUWE7CXeMeta?.alias || [],
    redirect: CallCenterJitUWE7CXeMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/CallCenter.vue").then(m => m.default || m)
  },
  {
    name: FaxCBlsAbvg6ZMeta?.name ?? "products-Fax",
    path: FaxCBlsAbvg6ZMeta?.path ?? "/products/Fax",
    meta: FaxCBlsAbvg6ZMeta || {},
    alias: FaxCBlsAbvg6ZMeta?.alias || [],
    redirect: FaxCBlsAbvg6ZMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/Fax.vue").then(m => m.default || m)
  },
  {
    name: cloud_45call_45centerMrE01gvl9SMeta?.name ?? "products-cloud-call-center",
    path: cloud_45call_45centerMrE01gvl9SMeta?.path ?? "/products/cloud-call-center",
    meta: cloud_45call_45centerMrE01gvl9SMeta || {},
    alias: cloud_45call_45centerMrE01gvl9SMeta?.alias || [],
    redirect: cloud_45call_45centerMrE01gvl9SMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-call-center.vue").then(m => m.default || m)
  },
  {
    name: cloud_45callcenterTh0GGDF8tVMeta?.name ?? "products-cloud-callcenter",
    path: cloud_45callcenterTh0GGDF8tVMeta?.path ?? "/products/cloud-callcenter",
    meta: cloud_45callcenterTh0GGDF8tVMeta || {},
    alias: cloud_45callcenterTh0GGDF8tVMeta?.alias || [],
    redirect: cloud_45callcenterTh0GGDF8tVMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-callcenter.vue").then(m => m.default || m)
  },
  {
    name: cloud_45pbxBO2TGEUONVMeta?.name ?? "products-cloud-pbx",
    path: cloud_45pbxBO2TGEUONVMeta?.path ?? "/products/cloud-pbx",
    meta: cloud_45pbxBO2TGEUONVMeta || {},
    alias: cloud_45pbxBO2TGEUONVMeta?.alias || [],
    redirect: cloud_45pbxBO2TGEUONVMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/cloud-pbx.vue").then(m => m.default || m)
  },
  {
    name: crm4OISCaAjElMeta?.name ?? "products-crm",
    path: crm4OISCaAjElMeta?.path ?? "/products/crm",
    meta: crm4OISCaAjElMeta || {},
    alias: crm4OISCaAjElMeta?.alias || [],
    redirect: crm4OISCaAjElMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/crm.vue").then(m => m.default || m)
  },
  {
    name: dedicated_45applicationQI9RmwjfMJMeta?.name ?? "products-dedicated-application",
    path: dedicated_45applicationQI9RmwjfMJMeta?.path ?? "/products/dedicated-application",
    meta: dedicated_45applicationQI9RmwjfMJMeta || {},
    alias: dedicated_45applicationQI9RmwjfMJMeta?.alias || [],
    redirect: dedicated_45applicationQI9RmwjfMJMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/dedicated-application.vue").then(m => m.default || m)
  },
  {
    name: internet_45phonerJwW5u5123Meta?.name ?? "products-internet-phone",
    path: internet_45phonerJwW5u5123Meta?.path ?? "/products/internet-phone",
    meta: internet_45phonerJwW5u5123Meta || {},
    alias: internet_45phonerJwW5u5123Meta?.alias || [],
    redirect: internet_45phonerJwW5u5123Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/internet-phone.vue").then(m => m.default || m)
  },
  {
    name: management_45dashboardKMxp116hpKMeta?.name ?? "products-management-dashboard",
    path: management_45dashboardKMxp116hpKMeta?.path ?? "/products/management-dashboard",
    meta: management_45dashboardKMxp116hpKMeta || {},
    alias: management_45dashboardKMxp116hpKMeta?.alias || [],
    redirect: management_45dashboardKMxp116hpKMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/management-dashboard.vue").then(m => m.default || m)
  },
  {
    name: smart_45IVROfgrDU3OnPMeta?.name ?? "products-smart-IVR",
    path: smart_45IVROfgrDU3OnPMeta?.path ?? "/products/smart-IVR",
    meta: smart_45IVROfgrDU3OnPMeta || {},
    alias: smart_45IVROfgrDU3OnPMeta?.alias || [],
    redirect: smart_45IVROfgrDU3OnPMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/smart-IVR.vue").then(m => m.default || m)
  },
  {
    name: smsbBuPq0ABjlMeta?.name ?? "products-sms",
    path: smsbBuPq0ABjlMeta?.path ?? "/products/sms",
    meta: smsbBuPq0ABjlMeta || {},
    alias: smsbBuPq0ABjlMeta?.alias || [],
    redirect: smsbBuPq0ABjlMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/sms.vue").then(m => m.default || m)
  },
  {
    name: virtual_45office0raXkWEjgBMeta?.name ?? "products-virtual-office",
    path: virtual_45office0raXkWEjgBMeta?.path ?? "/products/virtual-office",
    meta: virtual_45office0raXkWEjgBMeta || {},
    alias: virtual_45office0raXkWEjgBMeta?.alias || [],
    redirect: virtual_45office0raXkWEjgBMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/virtual-office.vue").then(m => m.default || m)
  },
  {
    name: webchata1PeYWFmnSMeta?.name ?? "products-webchat",
    path: webchata1PeYWFmnSMeta?.path ?? "/products/webchat",
    meta: webchata1PeYWFmnSMeta || {},
    alias: webchata1PeYWFmnSMeta?.alias || [],
    redirect: webchata1PeYWFmnSMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/products/webchat.vue").then(m => m.default || m)
  },
  {
    name: rondEZjXEp97X1Meta?.name ?? "rond",
    path: rondEZjXEp97X1Meta?.path ?? "/rond",
    meta: rondEZjXEp97X1Meta || {},
    alias: rondEZjXEp97X1Meta?.alias || [],
    redirect: rondEZjXEp97X1Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/rond.vue").then(m => m.default || m)
  },
  {
    name: sales_45agentl86NcZKjZ7Meta?.name ?? "sales-agent",
    path: sales_45agentl86NcZKjZ7Meta?.path ?? "/sales-agent",
    meta: sales_45agentl86NcZKjZ7Meta || {},
    alias: sales_45agentl86NcZKjZ7Meta?.alias || [],
    redirect: sales_45agentl86NcZKjZ7Meta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/sales-agent.vue").then(m => m.default || m)
  },
  {
    name: wf_45iranelecomp_45leadLVHDNJcolwMeta?.name ?? "wf-iranelecomp-lead",
    path: wf_45iranelecomp_45leadLVHDNJcolwMeta?.path ?? "/wf-iranelecomp-lead",
    meta: wf_45iranelecomp_45leadLVHDNJcolwMeta || {},
    alias: wf_45iranelecomp_45leadLVHDNJcolwMeta?.alias || [],
    redirect: wf_45iranelecomp_45leadLVHDNJcolwMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-iranelecomp-lead.vue").then(m => m.default || m)
  },
  {
    name: wf_45iranelecomp_45salesagentnifvuYqcxIMeta?.name ?? "wf-iranelecomp-salesagent",
    path: wf_45iranelecomp_45salesagentnifvuYqcxIMeta?.path ?? "/wf-iranelecomp-salesagent",
    meta: wf_45iranelecomp_45salesagentnifvuYqcxIMeta || {},
    alias: wf_45iranelecomp_45salesagentnifvuYqcxIMeta?.alias || [],
    redirect: wf_45iranelecomp_45salesagentnifvuYqcxIMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-iranelecomp-salesagent.vue").then(m => m.default || m)
  },
  {
    name: wf_45irantelecom_45leadQSaS0wNxXJMeta?.name ?? "wf-irantelecom-lead",
    path: wf_45irantelecom_45leadQSaS0wNxXJMeta?.path ?? "/wf-irantelecom-lead",
    meta: wf_45irantelecom_45leadQSaS0wNxXJMeta || {},
    alias: wf_45irantelecom_45leadQSaS0wNxXJMeta?.alias || [],
    redirect: wf_45irantelecom_45leadQSaS0wNxXJMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-irantelecom-lead.vue").then(m => m.default || m)
  },
  {
    name: wf_45irantelecom_45salesagenthygLvr0wPkMeta?.name ?? "wf-irantelecom-salesagent",
    path: wf_45irantelecom_45salesagenthygLvr0wPkMeta?.path ?? "/wf-irantelecom-salesagent",
    meta: wf_45irantelecom_45salesagenthygLvr0wPkMeta || {},
    alias: wf_45irantelecom_45salesagenthygLvr0wPkMeta?.alias || [],
    redirect: wf_45irantelecom_45salesagenthygLvr0wPkMeta?.redirect || undefined,
    component: () => import("C:/inetpub/gitlab-runner/navatel.ir-new-website/pages/wf-irantelecom-salesagent.vue").then(m => m.default || m)
  }
]